import React, {Component} from 'react';
import {connect} from "react-redux";

import {Row, Col} from 'reactstrap';

import * as actions from '../../actions/SearchActions';

import SearchHeader from '../../components/SearchHeader/SearchHeader'
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";

class ImpressumContainer extends Component {

    render() {

        return (
            <Content>

                <Section>
                    <Row>
                        <Col>
                            <h1>Impressum</h1>
                            <h2>Angaben gemäß § 5 TMG:</h2>
                            <p>Quickdoctor UG (haftungsbeschränkt)</p>
                            <h3>Postanschrift:</h3>
                            <p>Entrepreneurship Zentrum Witten (EZW)<br />
                              Bahnhofstr. 63<br />
                              58452 Witten<br />
                            </p>
                            <h3>Kontakt:</h3>
                            <p>Telefon: 00491704185699<br/>E-Mail: support@quickdoctor.de</p>
                            <h3>Vertreten durch:</h3>
                            <p>Geschäftsführerin Nina Sofie Krah,
                                <br/>Geschäftsführer Max Schüler,
                                <br/>Geschäftsführer Lukas Liß</p>
                            <p></p>
                            <h3>Eingetragen am</h3>
                            <p>28.01.2019<br />
                              Immich
                            </p>
                            <p></p>
                            <h3>Umsatzsteuer-Identifikationsnummer</h3>
                            <p>348/5864/3632<br/></p>
                            <h2>Rechtliche Hinweise</h2>
                          <h3>Haftungsausschluss für Inhalte und Verlinkung</h3>
                          <p>Die bei quickdoctor.de aufgeführten Inhalte, Tipps und Beträge sind nach bestem Wissen und Gewissen sorgfältig zusammengestellt. Es wird kein Anspruch und keine Gewähr auf Vollständigkeit und Ausschließlichkeit der Inhalte gestellt. Die zur Verfügung gestellten Informationen ersetzen keine individuellen medizinische Beratung/Konsultation eines Arztes. Sie sind unverbindlich und nicht Gegenstand eines Beratungsvertrages.<br /><br />
                            Die Quickdoctor UG (haftungsbeschränkt) behält sich das Recht vor, ohne vorherige Ankündigung die bereitgestellten Informationen zu ändern, zu ergänzen oder zu entfernen. Die Verweise durch Hyperlinks auf Inhalte fremder Webseiten dienen lediglich der Information. Die Quickdoctor UG (haftungsbeschränkt) hat auf die aktuelle oder zukünftige Gestaltung und die Inhalte der verlinkten Seiten keinerlei Einfluss. Daher distanziert sich die Quickdoctor UG (haftungsbeschränkt) trotz regelmäßiger Überprüfung der gesetzten Links hiermit ausdrücklich von allen Inhalten aller gelinkten Seiten. Jegliche Haftung im Zusammenhang mit der Nutzung der Informationen, der Links oder dem Vertrauen auf deren Richtigkeit wird somit ausgeschlossen. Falls in diesem Online-Auftritt auf Seiten verwiesen wird, deren Inhalt Anlass zur Beanstandung gibt, bitten wir um Hinweis an uns unter:<br /><br />
                            <a href="mailto:support@quickdoctor.de">support@quickdoctor.de</a> </p>

                          <h3>Urheberrechte</h3>
                          <p>Der gesamte Inhalt sowie die Struktur dieser Website (Texte, Bilder, Grafiken, Icons, Animationen) unterliegen dem Urheberrecht, das bei der Quickdoctor UG (haftungsbeschränkt) oder einem Dritten, der der Quickdoctor UG (haftungsbeschränkt) die entsprechenden Nutzungsrechte übertragen hat, liegt. Alle Rechte bleiben vorbehalten. Die Vervielfältigung im Wege des Herunterladens auf dauerhafte Datenträger und/oder des Ausdrucks auf Papier sowie die Weiterverbreitung ist nur bezüglich solcher Materialien gestattet, bei denen hierzu ausdrücklich aufgefordert wird (AGB, Datenschutzhinweis). Jede andere Nutzung des urheberrechtlich geschützten Materials ist ohne unsere schriftliche Genehmigung untersagt. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>

                          <h3>Anwendbares Recht</h3>
                            <p>Die rechtlichen Hinweise auf dieser Seite sowie alle Fragen und Streitigkeiten im Zusammenhang mit dieser Website unterliegen dem Recht der Bundesrepublik Deutschland unter Ausschluss der Regelungen zum UN-Kaufrecht sowie des internationalen Privatrechts.<br /><br />
                              Letzte Aktualisierung: Mai 2019<br /><br />
                              Soweit nicht anders angegeben, gilt dieses Datum der Aktualisierung für alle Seiten unter quickdoctor.de<br /><br />
                              Dieses Impressum gilt auch für die Präsenzen von Quickdoctor auf anderen Webseiten, unter anderem auch für die Seiten auf Facebook, Instagram, LinkedIn und Twitter.<br /><br />
                            </p>

                                <h2>Hinweis</h2>
                            <p>Die Plattform der EU zur außergerichtlichen Streitbeilegung finden Sie online unter: <a
                                href="https://ec.europa.eu/consumers/odr/">https://ec.europa.eu/consumers/odr/</a></p>
                            <p></p>
                            <p>
                                <em>Das Impressum wurde mit dem <a
                                    href="https://www.activemind.de/datenschutz/impressums-generator/">Impressums-Generator
                                    der activeMind AG</a> erstellt.</em>
                            </p>

                        </Col>
                    </Row>
                </Section>


            </Content>
        )
    }
}

export default ImpressumContainer;



// WEBPACK FOOTER //
// ./src/container/public/ImpressumContainer.js